// Configuration for the table actions (edit, delete, activate)
import { SERVICE_CONFIG_MESSAGES } from "../../../utils/message";

export const ServiceTypeTableConfig = {
  columns: [
    { key: "count", header: "S.", isSortable: false, className: "count" },
    {
      key: "serviceName",
      header: "Service Name",
      isSortable: true,
      className: "dark",
    },
    {
      key: "description",
      header: "Description",
      isSortable: true,
      className: "dark",
    },
    {
      key: "shortName",
      header: "Short Name",
      isSortable: true,
      className: "dark",
    },
    {
      key: "agentType",
      header: "Agent Type",
      isSortable: true,
      className: "dark",
    },
    {
      key: "deliverWithin",
      header: "Deliver Within",
      isSortable: true,
      className: "dark",
    },
    {
      key: "logisticsType",
      header: "Service Type",
      isSortable: true,
      className: "dark",
    },
    // {
    //   key: "onwardServiceName",
    //   header: "Onward Service",
    //   isSortable: true,
    //   className: "dark",
    // },
    {
      key: "comment",
      header: "Comments",
      isSortable: true,
      className: "dark",
    },
    {
      key: "dispatchColor",
      header: "Dispatch Color",
      isSortable: false,
      className: "dark",
      //   isActive: true,
      colorPallete: true,
    },
    {
      key: "active",
      header: "Active",
      isSortable: false,
      isActive: true,
      className: "dark",
    },
  ],
  edit: {
    apiUrl: "/service/updateService/",
    urlID: "id",
    stateData: false,
  },
  delete: {
    apiUrl: "service/deleteService/",
    urlID: "id",
    successMessage: SERVICE_CONFIG_MESSAGES.SERVICE_DELETE_SUCCESS,
    heading: SERVICE_CONFIG_MESSAGES.SERVICE_DELETE_HEADING,
    para: "delete",
    rowName: "serviceName",
    secondRowName: "",
    deleteByPutApi: true,
  },
  active: {
    apiUrl: "",
    urlID: "id",
    successMessage: "Additional Charges",
    heading: "Additional Charges!",
    para: "",
    rowName: "additionalCharges",
    secondRowName: "",
    onboardedMessage: "Additional Charges",
  },
};

export interface ServiceTypeResponseType {
  id: string;
  count: string | number;
  name: string;
  onwardServiceName?: string;
  vehicleType: string;
  shortName: string;
  longName: string;
  deliverWithin: string;
  dispatchTicketColor: string;
  dispatchPrinter: string;
  agentType: any;
  agentTypeId: any;
  useOver150Lbs: boolean;
  description: string;
  logisticsType: string;
  serviceDays: string[];
  minsNotReceiveMsg: string;
  minsNotReadMsg: string;
  zoneSet: string;
  delSignRequired: boolean;
  printDispatchTrack: boolean;
  orderDispatch: boolean;
  notReceivedMsgAlert: boolean;
  notReadMsgAlert: boolean;
  skipPickupStops: boolean;
  skipDelRoundStops: boolean;
  availCust: boolean;
  discInvoiceLevel: boolean;
  comment: string;
  canCustomerUse: boolean;
  disInvoiceLevel: boolean;
  isActive: boolean;
}


// Configuration for the table actions (edit, delete, activate)

export const OrderStatusTableConfig = {
  columns: [
    { key: "count", header: "S.", isSortable: false, className: "count" },
    {
      key: "serviceName",
      header: "Service Name",
      isSortable: true,
      className: "dark",
    },
    {
      key: "onwardServiceName",
      header: "Onward Service Name",
      isSortable: true,
      className: "dark",
    },
  ],
  edit: {
    apiUrl: "/order-status/update/",
    urlID: "id",
    stateData: false,
  },
  // delete: {
  //   apiUrl: "order-status/delete/",
  //   urlID: "id",
  //   successMessage: "Order status deleted successfully!",
  //   heading: "Delete Order Status!",
  //   para: "delete",
  //   rowName: "serviceName",
  //   secondRowName: "",
  //   deleteByPutApi: true,
  // },
  // active: {
  //   apiUrl: "",
  //   urlID: "id",
  //   successMessage: "Order Status",
  //   heading: "Order Status!",
  //   para: "",
  //   rowName: "serviceName",
  //   secondRowName: "",
  //   onboardedMessage: "Order Status",
  // },
};

export interface OrderStatusResponseType {
  id: string;
  count: string | number;
  name: string;
  onwardServiceName?: string;
  isActive: boolean;
}